import MultiSelect, {
  MultiSelectInput,
  MultiSelectList,
  MultiSelectOption,
  MultiSelectChip,
} from '@seaweb/coral/components/MultiSelect';
import useControlProp from '@seaweb/coral/hooks/useControlProp';
import { func, arrayOf, shape, number, string, bool } from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { useGetRequestCamelized } from 'hooks/useGetRequest';

import messages from './messages';

const MAX_TAG = 2;

function MultiSelectOfficeLocation({
  value: valueProp,
  initialValue = [],
  onChange,
  singleLineMode,
  ...props
}) {
  const [value, setValue] = useControlProp(valueProp, initialValue, onChange);

  const [officeRes] = useGetRequestCamelized(`/org/offices/v3/dropdown`);
  const { offices = [] } = officeRes || {};

  const officeMap = {};
  if (offices) {
    offices.forEach((loc) => {
      officeMap[loc.id] = loc;
    });
  }

  return (
    officeRes && (
      <MultiSelect
        value={value.map((ele) => ele.id)}
        onChange={(val) => setValue(val.map((id) => officeMap[id]))}
      >
        <MultiSelectInput
          data-multi-select-office-location-button=""
          searchElement={null}
          placeholder={<FormattedMessage {...messages.selectOffice} />}
          {...props}
        >
          {singleLineMode && (
            <>
              {value.slice(0, MAX_TAG).map((val) => (
                <MultiSelectChip key={val.id} value={val.id}>
                  {val.name}
                </MultiSelectChip>
              ))}
              {value.length > MAX_TAG && (
                <MultiSelectChip
                  index={value.length - 1}
                  value={value[value.length - 1].id}
                >
                  {`+ ${value.length - MAX_TAG}`}
                </MultiSelectChip>
              )}
            </>
          )}
        </MultiSelectInput>

        <MultiSelectList>
          {offices.map((ele) => (
            <MultiSelectOption key={ele.id} value={ele.id}>
              {ele.name}
            </MultiSelectOption>
          ))}
        </MultiSelectList>
      </MultiSelect>
    )
  );
}

const valuePropType = arrayOf(
  shape({ id: number.isRequired, name: string.isRequired })
);

MultiSelectOfficeLocation.propTypes = {
  value: valuePropType,
  initialValue: valuePropType,
  onChange: func.isRequired,
  singleLineMode: bool,
};

export default MultiSelectOfficeLocation;
